import { Directive, Input, ViewContainerRef, OnInit, ComponentFactoryResolver } from '@angular/core';
import { SchemaField, Document } from '../../store/models/document.model';
import { ColumnTypeMapService } from './column-type-map.service';
import { DynamicColumn } from './dynamic-column';
@Directive({
    selector: '[topoDynamicColumn]',
    standalone: false
})
export class DynamicColumnDirective implements OnInit {
  @Input() field: SchemaField;
  @Input() document: Document;

  constructor(
    private view: ViewContainerRef,
    private resolver: ComponentFactoryResolver,
    private columnComponentMap: ColumnTypeMapService
  ) {}

  ngOnInit() {
    const dataType = this.field.dataType;

    const componentType = this.columnComponentMap.getComponentByDataType(this.field.dataType);
    if (!componentType) {
      return;
    }

    const factory = this.resolver.resolveComponentFactory(componentType);

    // create the column component
    const component: any = this.view.createComponent(factory);
    const column = component.instance as DynamicColumn;

    // pass the document and field to the column for rendering
    column.document = this.document;
    column.field = this.field;
  }
}
